/*
 * @Description: 
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-01-06 17:56:11
 * @LastEditors  : zhouhong07
 * @LastEditTime : 2020-02-11 14:42:51
 */
//cookie封装
function cookie() {}
cookie.prototype.add = add;
cookie.prototype.get = function(name) {
    var nameEQ = name + "=";
    var arr = document.cookie.split(";");
    for (var i = 0; i < arr.length; i++) {
        var str = arr[i];
        while (str.charAt(0) === " ") {
            str = str.substring(1, str.length);
        }
        if (str.indexOf(nameEQ) === 0) return decodeURIComponent(str.substring(nameEQ.length, str.length));
    }
    return null;
}
cookie.prototype.del = del;
cookie.prototype.delAll = function(url) {
    var strCookie = document.cookie;
    // 将多cookie切割为多个名/值对  
    var arrCookie = strCookie.split("; ");
    // 遍历cookie数组，处理每个cookie对    
    for (var i = 0; i < arrCookie.length; i++) {
        var arr = arrCookie[i].split("=");
        if (arr.length > 0) del(arr[0], (url || window.location.hostname));
    }
}
function add(name, value, time, domain, path) {
    var maxAgeStr = "; max-age=" + time;
    var domainStr = "; domain=" + (domain || window.location.hostname);
    var pathStr = "; path=" + (path || '/');
    var str = name + "=" + encodeURIComponent(value) + maxAgeStr + domainStr + pathStr;
    document.cookie = str;
}
function del(name, url) {
    add(name, "", 0, url);
}
const Cookie = new cookie();

export default Cookie ;